/**
 * Canonical organization identity resolution.
 *
 * The dashboard addresses organizations by UUID: `/site/?org_uu_id=…` requires a
 * UUID, and since the backend org-scope fix `org_id` accepts either a UUID or an
 * integer pk. Resolving identity in one place keeps the header scope selector and
 * the scan manager modals from disagreeing about what "the selected org" means.
 */

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isOrgUuid(value) {
  return UUID_RE.test(String(value ?? '').trim());
}

/** Prefers the UUID; falls back to the integer pk only when no UUID exists. */
export function resolveOrgIdentity(org) {
  const uuid = org?.uu_id ?? org?.org_uuid ?? org?.organization_uuid;
  if (uuid !== undefined && uuid !== null && String(uuid).trim() !== '') return String(uuid).trim();
  const id = org?.id;
  if (id !== undefined && id !== null && String(id).trim() !== '') return String(id).trim();
  return '';
}

/**
 * Identity for `org_uu_id` parameters. Returns '' rather than an integer pk so a
 * non-UUID can never be sent as a UUID.
 */
export function resolveOrgUuid(org) {
  const identity = resolveOrgIdentity(org);
  return isOrgUuid(identity) ? identity : '';
}
